import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SummaryService } from './summary.service';
import { AxChartComponent, AxGridComponent } from 'src/app/shared/components';
import { Router } from '@angular/router';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements AfterViewInit {
  @ViewChild(AxChartComponent) chart!: AxChartComponent;
  @ViewChild(AxGridComponent) grid!: AxGridComponent;

  constructor(
    public summary: SummaryService,
    private router: Router
  ) { }

  ngAfterViewInit() {
    this.chart.series = [
      {
        type: 'line',
        argumentField: 'date_col',
        valueField: 'p',
        name: 'Portfolio'
      },
      {
        type: 'line',
        argumentField: 'date_col',
        valueField: 'b',
        name: 'Benchmark'
      },
      {
        type: 'line',
        argumentField: 'date_col',
        valueField: 'd',
        name: 'Active'
      }
    ];

    this.chart.argumentAxis = {
      argumentType: 'datetime',
      tickInterval: {
        days: 1
      },
      label: {
        format: {
          type: 'shortDate'
        }
      }
    };

    this.grid.columns = [
      {
        dataField: 'date_col',
        dataType: 'date',
        caption: 'Date',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'p',
        dataType: 'number',
        caption: 'Portfolio',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'b',
        dataType: 'number',
        caption: 'Benchmark',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'd',
        dataType: 'number',
        caption: 'Active',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      }
    ];

    this.chart.showLoadingIndicator();
    this.grid.showLoadingIndicator();
    this.summary.retrieve().subscribe(
      data => {
        let jsonObj = JSON.parse(data);
        this.chart.dataSource = jsonObj;
        this.grid.dataSource = jsonObj;
        let bdate = jsonObj.slice(-1)[0].date_col;
        this.summary.analysisDate = new Date(bdate);
      })
      .add(() => {
        this.chart.hideLoadingIndicator();
        this.grid.hideLoadingIndicator();
      });
  }

  pointClickedHandler(e: any) {
    /* disable parcoords
    var point = e.target;
    this.summary.analysisDate = new Date(point.argument);
    this.summary.seriesName = point.series.name;
    this.router.navigate(['/gfr-parcoords', '' + this.summary.reportId, this.summary.analysisDate.toISOString(), point.series.name]);
    */
  }
}
